export default __webpack_public_path__ + "static/125-6cc7d88bc504c504d608e8f31e3be815.jpg";